module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"ranking":"ランキング","hourly":"1時間ごと","last_hour":"最近1時間","daily":"24時間ごと","last_day":"最近24時間","weekly":"1週間ごと","last_week":"最近1週間","monthly":"1ヶ月ごと"},"en":{"ranking":"Ranking","hourly":"hourly","last_hour":"in the last hour","daily":"daily","last_day":"in the last day","weekly":"weekly","last_week":"in the last week","monthly":"monthly"}}')
  delete Component.options._Ctor
}
